import GOT from './GOT';
import StringUtil from './StringUtil';
import ArgCallerType from '../forms/sys/ArgCallerType';
import AuthorityUtil from './AuthorityUtil';
import Warn from './Warn';

export default class FormLoadHelper
{

	static openFormDirectly(options)
	{
		let defaults = {
			parm:null,										   
			fm:null, 
			group:null, 
			mainTableWhereValues:null,
			callerKey:null,
			paramObject:null,
			popUp:false,
			checkHas:true,
			addJoin:true,
			onlyQuery:false,
			label:""
		};
		let extendArg = Object.assign(defaults,options);
		if(extendArg.checkHas)
		{
			var _parentWindow = (typeof(window.switchToRelatedForm) == "function")?window:window.parent.window;
			if(_parentWindow)
			{
				var has = _parentWindow.switchToRelatedForm(extendArg.callerKey,window.formModuleInstanceuuId);
				if(has)
					return;
			}
		}
		
		
		var formId = defaults.formId;		
		
		var argCaller = {};
		argCaller.authorityObject = extendArg.authorityArg;
		if(extendArg.fm)
		{
			argCaller.type = ArgCallerType.FormModule;
			argCaller.calleruuId = window.formModuleInstanceuuId;
			argCaller.callerMenuItemId = window.menuItemId;
			argCaller.callerFormId = window.formId;
			argCaller.callerKey = extendArg.callerKey;
			if(extendArg.parm)
				argCaller.parameters = extendArg.parm;
			else
				argCaller.parameters = "";
			
			argCaller.paramObject = extendArg.paramObject;
			argCaller.autoJoinParentArg = extendArg.autoJoinParentArg;
			if(extendArg.addJoin && !extendArg.group)
			{
				if(extendArg.fm.formDataSources)
					extendArg.group = extendArg.fm.formDataSources.currentGroup;
			}
			
			if(extendArg.group)
			{				
				argCaller.joinGroupAlias = extendArg.group.mainSource.alias;				
			}
			
		}
		else
		{
			argCaller.type = ArgCallerType.MainMenu;
			if(extendArg.parm)
				argCaller.parameters = extendArg.parm;
			else
				argCaller.parameters = "";
			argCaller.paramObject = extendArg.paramObject;
			
		}
		
		if(extendArg.mainTableWhereValues)
		{
			argCaller.enterMainForm = true;
			argCaller.mainTableWhereValues = extendArg.mainTableWhereValues;
			argCaller.callerType = ArgCallerType.MainForm;
		}
		var _parentWindow = (typeof(window.openMenuItem) == 'function')?window:window.parent.window;
		if(_parentWindow)
		{
			if(typeof(_parentWindow.openMenuItem)=='function')
			{
				_parentWindow.openMenuItem(
					{menuItemId:extendArg.menuItemId,formId:formId,argCaller:argCaller,onlyQuery:extendArg.onlyQuery,
						popUp:extendArg.popUp,label:extendArg.label,fixedUrl:'',manual:extendArg.manual,
						menuItem:extendArg.menuItem,fromMainMenu:extendArg.fromMainMenu}
				);
			}
		}
	}

	static openMenuItemByAuthority(options)
	{
		let defaults = {
			parm:null,										   
			fm:null, 
			group:null, 
			mainTableWhereValues:null,
			callerKey:null,
			paramObject:null,
			popUp:false,
			checkHas:true,
			addJoin:true,
			onlyQuery:false,
			label:""
		};
		let extendArg = Object.assign(defaults,options);
		if(extendArg.checkHas)
		{
			var _parentWindow = (typeof(window.switchToRelatedForm) == "function")?window:window.parent.window;
			if(_parentWindow)
			{
				var has = _parentWindow.switchToRelatedForm(extendArg.callerKey,window.formModuleInstanceuuId);
				if(has)
					return;
			}
		}
		if(extendArg.parm && extendArg.parm.ingnoreAu)
		{
			FormLoadHelper.openMenuItem(extendArg);
		}
		else
		{
			var authorityObject = AuthorityUtil.getAuthorityMenuItem(extendArg.menuItemId);
			if(authorityObject["query"] == true)
			//if(ClientSessionAuthority.getAuthorityMenuItem(menuItemId)==true)
			{
				if(authorityObject["del"] == false)
					extendArg.onlyQuery = true;
				FormLoadHelper.openMenuItem(extendArg);
			}
			else
			{
				let _formName = extendArg.label;
				if(extendArg.fm)
					_formName = extendArg.fm.formLabel;
				Warn.show({text:"您所在的用户组没有打开该页面的权限<br>页面名称："+_formName+"<br>菜单项ID："+extendArg.menuItemId});
				
			}
		}
		
	}

	static openHtml(url,params) 
	{ 
		if(params.indexOf("newwindow=true")!=-1 || params.indexOf("newWindow=true")!=-1)
		{
			   	window.open(url);
			   	return;
		}
		   
	   var width,height;
	   if(params.indexOf("width=")==-1)
	   {
	   		params+=(",width=800");width=800;
	   }
	   else
	   {
	   		var reg = new RegExp("(^|,)"+ "width" +"=([^,]*)(,|$)");
			var r = params.match(reg);
			if(r!=null)
			{
				width = unescape(r[2]);
			}
	   }
	   if(params.indexOf("height=")==-1)
	   {
	   		params+=(",height=600");height=600;
	   }
	   else
	   {
	   		var reg = new RegExp("(^|,)"+ "height" +"=([^,]*)(,|$)");
			var r = params.match(reg);
			if(r!=null)
			{
				height = unescape(r[2]);
			}
	   }
	   if(height!=undefined && params.indexOf("top=")==-1)
	   {
	   		var atop=(screen.availHeight - height)/2;
	   		params+=(",top="+atop);
	   }
	   if(width!=undefined && params.indexOf("left=")==-1)
	   {
	   		var aleft=(screen.availWidth - width)/2;
	   		params+=(",left="+aleft);	
	   }
	   if(params.indexOf(",")==0)
	   		params=params.substr(1);
		let name ="";
		if(params.indexOf('name=') != -1){
			name = params.split('name=')[1];
			name = name.split(",")[0];
		}
	   	window.open(url,name,params);
	}

	static openMenuItem(options)
	{
		let defaults = {
			menuItemId:"",parm:null,fm:null,group:null,mainTableWhereValues:null,authorityArg:null,
			callerKey:null,paramObject:null,popUp:false,addJoin:true,onlyQuery:false,label:""
		};
		let extendArg = Object.assign(defaults,options);
		var menuItem = GOT.getMenuItem(extendArg.menuItemId);
		if(!menuItem)
			return;
		
		var refPro = menuItem.Properties.RefObject || menuItem.Properties.Source;
		var source = menuItem.Properties.RefObject?menuItem.Properties.Source.V:menuItem.Properties.SourceType.V;
		if(menuItem.Properties.Popup && menuItem.Properties.Popup.V == "true")
			extendArg.popUp = true;

		var formId = refPro.refentityid;
		var formName = refPro.V;
		let fixedUrl = "";
		if(source == "Html")
		{
			try
			{
				if(menuItem.Properties.URL)
					formName = menuItem.Properties.URL.V;
				

				if(window.didomain && !window.loginToken && !window.loginDataArea)
				{
					//如果不是http或者https开头
					if(formName.indexOf("http://")!=0 && formName.indexOf("https://")!=0)
					{
						formName = formName;
					}
				}
				else
				{
					if(formName.indexOf("http://")!=0 && formName.indexOf("https://")!=0)
					{
						//TODO_YL  修正
						//formName = "html/"+formName;	//TODO是否有效URL及安全性问题
						formName =formName
					}
				}
				var _parentWindow = window.hasOwnProperty("userInfos")?window:window.parent.window;
				var userInfos = _parentWindow.userInfos;var _key;var onlyQuery = false;
				if(!userInfos.isAdmin)
				{
					let got = window.got || window.parent.window.got;
					var menuItemInMain = GOT.getMainMenuMenuItemById(got.MainMenu,menuItem.id);
					if(menuItemInMain)
					{
						var moduleId = menuItemInMain.entityId;
						if(menuItemInMain.hasOwnProperty("idInMenu"))
						{
							_key = moduleId + "." + menuItemInMain.idInMenu;
						}
						else
						{
							_key = moduleId + "." + menuItemInMain.id;
						}
						
						var aus = AuthorityUtil.getXmlType1SCache()[_key];
						if(aus && aus.query && aus.del)
						{
							onlyQuery = true;
						}
					}
				}						
				
				var userId = userInfos.userId;
				var userGroups = userInfos.userGroups;
				var htmlsessionobj = {userId:userId,userGroups:userGroups,onlyQuery:onlyQuery}; 
				var htmlsessionjson = JSON.stringify(htmlsessionobj);
				sessionStorage.setItem(menuItem.id+".aus",htmlsessionjson);
				var params = menuItem.Properties.Parameters?menuItem.Properties.Parameters.V
															:menuItem.Properties.URL.V;
				if(!params)params = "";
				params = StringUtil.trimThrough(params).toLowerCase();
				FormLoadHelper.openHtml(formName,params);
				
			}catch(e)
			{
				
			}
			return;
		}
		else if(source == "Report")
		{
			if(window.menuItemToUrl && window.menuItemToUrl.hasOwnProperty(extendArg.menuItemId))
			{
				fixedUrl = window.menuItemToUrl[extendArg.menuItemId];
			}
		}
		
		var argCaller = {};
		argCaller.authorityObject = extendArg.authorityArg;
		if(extendArg.fm)
		{
			argCaller.type = ArgCallerType.FormModule;
			argCaller.calleruuId = window.formModuleInstanceuuId;
			argCaller.callerMenuItemId = window.menuItemId;
			argCaller.callerFormId = window.formId;
			argCaller.callerKey = extendArg.callerKey;
			argCaller.commandArgInfo = extendArg.commandArgInfo;
			if(!extendArg.parm) 
				argCaller.parameters = menuItem.Properties.Parameters?menuItem.Properties.Parameters.V
																	:menuItem.Properties.URL.V;
			else
				argCaller.parameters = extendArg.parm;
			
			argCaller.paramObject = extendArg.paramObject;
			argCaller.autoJoinParentArg = extendArg.autoJoinParentArg;
			if(extendArg.addJoin && !extendArg.group)
			{
				if(extendArg.fm.formDataSources)
					extendArg.group = extendArg.fm.formDataSources.currentGroup;
			}
			
			if(extendArg.group)
			{
				//argCaller.joinGroup = group;
				argCaller.joinGroupAlias = extendArg.group.mainSource.alias;
				
			}
			
		}
		else
		{
			argCaller.type = ArgCallerType.MainMenu;
			var parameters;
			if(!extendArg.parm) 
				argCaller.parameters = menuItem.Properties.Parameters?menuItem.Properties.Parameters.V
																	:menuItem.Properties.URL.V;
			else
				argCaller.parameters = extendArg.parm;
			
			argCaller.paramObject = extendArg.paramObject;
			
		}
		
		if(extendArg.mainTableWhereValues)
		{
			argCaller.enterMainForm = true;
			argCaller.mainTableWhereValues = extendArg.mainTableWhereValues;
			argCaller.callerType = ArgCallerType.MainForm;
		}
		var _parentWindow = (typeof(window.openMenuItem) == 'function')?window:window.parent.window;
		if(menuItem.name == "SysAuthoritySetup")
		//if(menuItem.Properties.LoadType && menuItem.Properties.LoadType == "Manual")
		{
			extendArg.manual = true;extendArg.menuItem = menuItem;extendArg.popUp=true;
			if(!_parentWindow.manualArgs)_parentWindow.manualArgs = {};
			let key = extendArg.menuItemId;
			_parentWindow.manualArgs[key] = extendArg.commandArg;

		}
		//window.openMenuItem(extendArg.menuItemId,formId,argCaller,extendArg.onlyQuery,extendArg.popUp,extendArg.label,fixedUrl);

		if(_parentWindow)
		{
			if(typeof(_parentWindow.openMenuItem)=='function')
			{
				_parentWindow.openMenuItem(
					{menuItemId:extendArg.menuItemId,formId:formId,argCaller:argCaller,onlyQuery:extendArg.onlyQuery,
						popUp:extendArg.popUp,label:extendArg.label,fixedUrl:fixedUrl,manual:extendArg.manual,
						menuItem:extendArg.menuItem,fromMainMenu:extendArg.fromMainMenu}
				);
			}
		}
		var _parentWindow2 = (typeof(window.setOperate) == 'function')?window:window.parent.window;
		if(_parentWindow2.setOperate){
			let remark={'title':'打开画面',"menuItemId":menuItem['id']};
			var data ={
				'dataArea':'dynamic',
				'userId':_parentWindow2.userInfos.userId,
				'userName':_parentWindow2.userInfos.userName,
				'clientSessionId':_parentWindow2.userInfos.userSessionId,
				'dateTime':new Date().getTime()+'',
				'operationId':'001',
				'formId':formId,
				'formDataSourceName':'',
				'formItemName':'',
				'remark':JSON.stringify(remark)
			};
			_parentWindow2.setOperate(data);
		}
		
	}
}


// WEBPACK FOOTER //
// ./src/utils/FormLoadHelper.js